Vue.component('stats', {
  template: templates.stats,
  data() {
    return {
      model: {
        stats: [{
            type: 'achievements',
            value: 0,
            icon: null
          },
          {
            type: 'wins',
            value: 0,
            icon: null
          },
          {
            type: 'losses',
            value: 0,
            icon: null
          },
          {
            type: 'packs',
            value: 0,
            icon: null
          },
          {
            type: 'cards',
            value: 0,
            icon: null
          },
          {
            type: 'keys',
            value: 0,
            icon: null
        }],
        icons: {
          wins: 'bi-emoji-sunglasses-fill',
          losses: 'bi-emoji-dizzy-fill',
          packs: 'bi-wallet-fill',
          cards: 'bi-collection-fill',
          achievements: 'bi-award-fill',
          keys: 'bi-key-fill',
        }
      }
    }
  },
  mounted() {
    const c = this;
    c.get();

    for (let stat of c.model.stats) {
      stats = c.getIcon(stat);
    }
  },
  methods: {
    get() {
      const c = this;

      userService.stats()
        .then(function (response) {
          for (let key in response.data) {
            c.setStatValue(key, response.data[key]);
          }
        })
        .catch(function (error) {
          
        });
    },
    setStatValue(type, value) {
      const c = this;

      for (let stat of c.model.stats) {
        if (stat.type == type) {
          stat.value = value;
          stat = c.getIcon(stat);
        }
      }
    },
    getIcon(stat) {
      const c = this;
      stat.icon = c.model.icons[stat.type];
    }
  }
});